<template lang="pug">
  .wrap
    select#primeselector(name="prime" v-model="activeprime")
      option(v-for="(prime, index) in primes" :value="prime.id" ) {{prime.title}}
</template>
<script>

import { mapActions } from 'vuex'

export default {
  props: {
    primes: Array
  },
  mounted(){
    // console.log(this.primes)
    // this.setActivePrime(this.primes[0].value)
  },
  data() {
    return {
      activeprime: 0
    }
  },
  watch: {
    activeprime(newactive, oldactive) {
      this.setActivePrime(newactive)
    },
    primes() {
      if(this.primes.length > 0){
        this.activeprime = this.primes[0].id
      }
    }
  },
  methods: {
    ...mapActions([
      'setActivePrime'
    ])
  }
}
</script>

<style lang="scss" scoped>
  select{
    font-size: 0.8rem;
    display: block;
  }
</style>
